import classNames from 'clsx';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import flow from 'lodash/flow';
import get from 'lodash/get';

import Checkmark from '../../shared/svgIcons/Checkmark';
import viewTypes from '../../../constants/auth/viewTypes';
import connectWithExperiments from '../../../decorators/connectWithExperiments';
import {
  AUTH_SUCCESS_SIGN_IN,
  AUTH_SUCCESS_SIGN_UP,
} from '../../../constants/localizations/auth';
import { AUTH_PAYMENT_FORM_PREVIEW_ENABLED } from '../../../constants/experiments/auth';
import { PAYMENT_FLOW } from '../../../constants/subscription/flow';
import cssVariables from '../../../styles/variables';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import css from './auth-success-text.module.scss';

const svgProps = {
  width: '13px',
  height: '10px',
  viewBox: '0 0 13 11',
  fill: cssVariables['--tunein-coral'],
};

// exported for testing
export class AuthSuccessText extends Component {
  static propTypes = {
    viewType: PropTypes.string,
    isRecurlyLoading: PropTypes.bool.isRequired,
    [AUTH_PAYMENT_FORM_PREVIEW_ENABLED]: PropTypes.bool,
  };

  static contextType = LocationAndLocalizationContext;

  render() {
    const {
      viewType,
      isRecurlyLoading,
      [AUTH_PAYMENT_FORM_PREVIEW_ENABLED]: isAuthPreviewEnabled,
    } = this.props;
    const { location, getLocalizedText } = this.context;

    if (!isAuthPreviewEnabled) {
      return null;
    }
    if (!location.query[PAYMENT_FLOW]) {
      return null;
    }

    const successText =
      viewType === viewTypes.signUp
        ? AUTH_SUCCESS_SIGN_UP
        : AUTH_SUCCESS_SIGN_IN;
    const successCss = isRecurlyLoading ? '' : css.successTextAnimation;

    return (
      <div
        className={classNames(css.successTextContainer, successCss)}
        data-testid="successTextContainer"
      >
        <Checkmark {...svgProps} />
        <span>{getLocalizedText(successText)}</span>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    viewType: get(state, 'fakeAuth.viewType'),
  };
}

export default flow(
  connectWithExperiments([AUTH_PAYMENT_FORM_PREVIEW_ENABLED]),
  connect(mapStateToProps),
)(AuthSuccessText);
